<template>
    <div class="row">
        <TitleComponent class="col-12 col-md-8" title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez" />
        <div class="col-12 col-md-4 mb-3 text-center">
            <template>
                <h3>ZONA SELECCIONADA:</h3>
                <h4 v-if="zona">{{ zona.name }}</h4>
            </template>
            <Button @click="cambiarPaso()" :disabled="bloquearPasoDos">Cambiar zona</Button>
        </div>
        <ContentOrLoading class="col-12">
            <template v-if="!loading">
                <div class="row h-100">
                    <div class="p-0 col-12 col-md-8">
                        <RecintoAnexoComponent
                            v-if="plazas"
                            ref="recintoAnexo"
                            class="col-12"
                            :region_id="zona.id"
                            :plazas="plazas"
                            :plazasSeleccionadas="[]"
                            :plazasSeleccionadasIds="plazasSeleccionadasIds"
                            :continuarConCompra="continuarConCompra"
                            :tipo_svg="parseInt(zona.tipo_svg, 10)"
                            :tipo_svg_taquilla="recinto && recinto.tipo_svg_taquilla"
                            :recinto_id="recinto && recinto.id"
                            :ocultarBorrarSeleccion="true"
                            :ocultarControlesSeleccion="diaAbonado"
                            :precios="precios"
                            :asientos_maximos="asientos_maximos"
                            :disabled="datosCompradores.length == 0"
                            :bloquearPasoDos="bloquearPasoDos"
                            :habilitarZoomRueda="true"
                            @clickZona="clickZona"
                            @clearButacas="clearButacas"
                        />
                    </div>
                    <div class="col-12 col-md-4 mt-3 mt-md-0">
                        <div class="d-block text-center d-md-flex justify-content-between align-items-center mb-3 pl-3 pr-3">
                            <h3 class="mt-2">TUS ASIENTOS</h3>
                            <Button @click="showModalBloquearAsientos()" :disabled="bloquearPasoDos || (datosCompradores && datosCompradores.length === 0)">BLOQUEAR / LIBERAR BUTACAS</Button>
                        </div>
                        <div class="col-12 text-center" v-if="datosCompradores && datosCompradores.length === 0">
                            <p>Seleccione los asientos para continuar</p>
                        </div>
                        <template v-else>
                            <div class="overflow-auto mb-2 p-2 p-md-0" style="max-height: 446px;">
                                <div v-for="(asiento, index) in plazasCompletas" :key="index">
                                    <TusPlazasComponent :butaca="asiento" :index="index" :disabled="bloquearPasoDos" @borrar-plaza="quitarPlaza" :key="index"/>
                                </div>
                            </div>
                            <div v-if="teatro.carrito_varios_eventos" class="d-flex flex-column tw:flex tw:flex-col tw:gap-2 align-items-stretch w-100 mt-3">
                                <Button v-if="(carrito && carrito.items_count == 0) || !carrito" @click="bloquearButacas" class="btn btn-primary" :disabled="bloquearPasoDos" style="flex: 1;">Continuar</Button>
                                <Button @click="borrarSeleccion" class="btn btn-primary" :disabled="bloquearPasoDos">Borrar selección</Button>
                                <Button id="add-cart" v-if="(carrito && carrito.items_count == 0) || !carrito" @click="checkCarrito()" class="btn btn-secondary tw:flex tw:items-center tw:justify-center" :disabled="bloquearPasoDos || disableButtonCart"><i class="fa fa-cart-plus" aria-hidden="true"></i></Button>
                                <Button id="add-cart" v-else @click="checkCarrito()" class="btn btn-secondary" :disabled="bloquearPasoDos || disableButtonCart" style="flex: 1;">AÑADIR AL CARRITO</Button>
                            </div>
                            <div v-else class="d-flex flex-column tw:flex tw:flex-col tw:gap-2 align-items-stretch w-100 mt-3">
                                <Button class="btn-block flex-fill" @click="bloquearButacas" :disabled="bloquearPasoDos">Continuar</Button>
                                <Button @click="borrarSeleccion" class="btn btn-primary" :disabled="bloquearPasoDos">Borrar selección</Button>
                            </div>
                        </template>
                    </div>
                    <BloquearButacas
                        v-if="datosCompradores.length > 0 && !bloquearPasoDos"
                        :butacas="datosCompradores"
                        @bloquearButacas="bloquearAsientosManual"
                        @close="closeModalBloquearAsientos"
                    />
                </div>
            </template>
        </ContentOrLoading>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import RecintoAnexoComponent from '@/components/svg/RecintoAnexoComponent';
    import TusPlazasComponent from '../components/TusPlazasComponent.vue';
    import BloquearButacas from '../components/BloquearButacas.vue';
    import { useAmigoAbonadoTaquilla } from '@/composables/admin/events/useAmigoAbonadoTaquilla';
    import { isFlagEnabled } from '@/utils/precios/filterPricesByFlag';

    const { preciosAmigoAbonadoDePlaza } = useAmigoAbonadoTaquilla();

    const BANDERA_TARIFA_ABONADO = 'dia_abonado';
    const BANDERA_TARIFA_ACOMPANANTE = 'acompanante_abonado';
    const BANDERA_TARIFA_AMIGO_ABONADO = 'amigo_abonado';

    function plazaTieneDatos(plaza) {
        if (!plaza || plaza.id === undefined || plaza.id === null) {
            return false;
        }

        const tieneNumero = plaza.numero !== undefined && plaza.numero !== null;
        const tieneButacaNumerada = plaza.butaca !== undefined && plaza.butaca !== null &&
            plaza.fila !== undefined && plaza.fila !== null;

        return tieneNumero || tieneButacaNumerada;
    }

    function tarifaMarcadaCon(tarifa, bandera) {
        if (!tarifa || typeof tarifa !== 'object') {
            return false;
        }

        return isFlagEnabled(tarifa[bandera]);
    }

    /**
     * Reparte el catálogo de tarifas por su bandera de rol: día abonado, acompañante o
     * amigo abonado. Las peticiones pueden devolver varias familias en la misma plaza, así
     * que cada flujo debe entregar únicamente la tarifa que le corresponde.
     *
     * Se consultan las listas en orden de prioridad y gana la primera que contenga alguna
     * tarifa del rol, de modo que un catálogo de zona incompleto nunca pisa la tarifa propia
     * que sí trae la plaza. El respaldo sin filtrar solo vale cuando ninguna tarifa trae
     * marcas de rol (catálogos de venta normal); si hay marcas y ninguna es la del rol, la
     * tarifa del otro rol no es un respaldo válido y se devuelve una lista vacía.
     */
    function tarifasDelRol(listas, bandera) {
        const disponibles = listas.filter(lista => Array.isArray(lista) && lista.length > 0);

        for (let i = 0; i < disponibles.length; i++) {
            const delRol = disponibles[i].filter(tarifa => tarifaMarcadaCon(tarifa, bandera));

            if (delRol.length > 0) {
                return delRol;
            }
        }

        const hayMarcasDeRol = disponibles.some(lista => lista.some(tarifa =>
            tarifaMarcadaCon(tarifa, BANDERA_TARIFA_ABONADO) ||
            tarifaMarcadaCon(tarifa, BANDERA_TARIFA_ACOMPANANTE) ||
            tarifaMarcadaCon(tarifa, BANDERA_TARIFA_AMIGO_ABONADO)
        ));

        // Con marcas de rol presentes, la lista del otro rol no sirve de respaldo.
        if (hayMarcasDeRol) {
            return [];
        }

        return disponibles.length > 0 ? disponibles[0] : [];
    }

    export default {
        props: {
            zona: { type: Object, default: null },
            datos_compradores: { type: Array, default: () => [] },
            precios: { type: Array, default: () => [] },
            continuarConCompra: { type: Boolean, default: false },
            recinto: { type: Object, default: null },
            asientos_maximos: { type: Number },
            bloquearPasoDos: { type: Boolean, default: false },
            diaAbonado: { type: Boolean, default: false },
            amigoAbonado: { type: Boolean, default: false },
            preciosAbonado: { type: Array, default: () => [] },
            preciosAcompanante: { type: Array, default: () => [] },
            preciosAmigoAbonado: { type: Array, default: () => [] },
            asientosMinimos: { type: Number },
            asientosMaximos: { type: Number },
            datosAbonado: { type: Object, default: null },
            continuarConAsiento: { type: Boolean, default: false },
            preseleccionarPlazaAbonado: { type: Boolean, default: false }
        },
        created() {
            this.inicializarRolAbonado();

            if (this.recinto) {
                this.getPlazas();
            }
        },
        data() {
            return {
                loading: false,
                plazas: null,
                disableButtonCart: false,
                datosCompradores: (this.datos_compradores || [])
                    .filter(comprador => !this.diaAbonado || plazaTieneDatos(comprador))
                    .map(comprador => ({ ...comprador })),
                abonadoPlazaId: null,
                plazasConocidasIds: []
            }
        },
        watch: {
            datos_compradores: {
                handler(datosCompradores) {
                    const compradores = datosCompradores || [];
                    const compradoresValidos = this.diaAbonado
                        ? compradores.filter(plazaTieneDatos)
                        : compradores;
                    this.datosCompradores = compradoresValidos.map(comprador => ({ ...comprador }));
                    this.actualizarRolAbonado();
                    this.actualizarPreciosAmigoAbonado();
                },
                deep: true
            },
            datosCompradores: {
                handler() {
                    this.sincronizarPlazasSeleccionadas();
                },
                deep: true
            }
        },
        methods: {
            esPlazaCompleta(plaza) {
                return plazaTieneDatos(plaza);
            },
            /**
             * Tarifas de la fila real de `butacas` de la plaza del comprador, solo si
             * vienen marcadas para su rol. La petición del día del abonado devuelve la
             * tarifa del abonado (`dia_abonado`) y la del acompañante
             * (`acompanante_abonado`) en la misma plaza, cada una con sus gastos de
             * taquilla. Se exige la marca para no pisar el catálogo de la zona cuando
             * la petición no alternó el catálogo (venta normal o respuesta sin banderas).
             */
            tarifasDeTaquillaDelMapa(comprador, bandera) {
                if (!comprador || !Array.isArray(this.plazas)) {
                    return null;
                }

                const plazaEnMapa = this.plazas.find(plaza => String(plaza.id) === String(comprador.id));
                const tarifas = plazaEnMapa && plazaEnMapa.precios;

                if (!Array.isArray(tarifas) || !tarifas.some(tarifa => tarifaMarcadaCon(tarifa, bandera))) {
                    return null;
                }

                return tarifas;
            },
            plazaDisponibleParaPreseleccion(plaza) {
                if (!this.esPlazaCompleta(plaza) || !Array.isArray(plaza.precios) || plaza.precios.length === 0 ||
                    !(plaza.libre || plaza.disponible)) {
                    return false;
                }

                if (plaza.bloqueada || plaza.bloqueada_abonos || plaza.ocupada || plaza.info_ocupada ||
                    (plaza.oculto && plaza.oculto > 0)) {
                    return false;
                }

                if (plaza.ocupado !== undefined && plaza.ocupado !== null && ![0, false, '0'].includes(plaza.ocupado)) {
                    return false;
                }

                const info = plaza.info || {};
                const abonadoId = this.datosAbonado && this.datosAbonado.id;
                const propietarioId = info.abonado_id || (info.abonado && info.abonado.id);
                const tieneMarcaDeAbonado = info.es_abonado === true || info.es_abonado === 1 ||
                    info.es_abonado === '1' || Number(info.abonado_lista_abonado_id) > 0;

                if (tieneMarcaDeAbonado && (!propietarioId || String(propietarioId) !== String(abonadoId))) {
                    return false;
                }

                return !propietarioId || String(propietarioId) === String(abonadoId);
            },
            clickZona(plazaSeleccionada) {
                const plazaEnMapa = this.plazas.find(plaza => String(plaza.id) === String(plazaSeleccionada.id));

                if (!plazaEnMapa) {
                    return;
                }

                const indiceSeleccionada = this.datosCompradores.findIndex(comprador => String(comprador.id) === String(plazaSeleccionada.id));

                if (indiceSeleccionada !== -1) {
                    this.datosCompradores = this.datosCompradores.filter(comprador => String(comprador.id) !== String(plazaSeleccionada.id));
                } else {
                    if ((this.diaAbonado || this.amigoAbonado) &&
                        this.datosCompradores.length >= this.asientosMaximos) {
                        this.$toast.error(`No puede seleccionar más de ${this.asientosMaximos} plazas`);
                        this.sincronizarPlazasSeleccionadas();
                        return;
                    }

                    this.datosCompradores.push({ ...plazaEnMapa });
                }

                this.actualizarPreciosAbonado();
                this.actualizarPreciosAmigoAbonado();
                this.sincronizarPlazasSeleccionadas();
            },
            sincronizarPlazasSeleccionadas() {
                if (Array.isArray(this.plazas)) {
                    this.plazas.forEach(plaza => {
                        const seleccionada = this.datosCompradores.some(comprador => String(comprador.id) === String(plaza.id));

                        if (plaza.seleccionada !== seleccionada) {
                            this.$set(plaza, 'seleccionada', seleccionada);
                        }
                    });
                }

                // Se le pasan los identificadores explícitamente para que el mapa repinte
                // con la lista actual sin depender de cuándo le llegue la prop.
                const recintoAnexo = this.$refs.recintoAnexo;

                if (recintoAnexo && typeof recintoAnexo.sincronizarMarcasSeleccionadas === 'function') {
                    recintoAnexo.sincronizarMarcasSeleccionadas(this.plazasSeleccionadasIds);
                }
            },
            quitarPlaza(plaza) {
                this.datosCompradores = this.datosCompradores.filter(comprador => String(comprador.id) !== String(plaza.id));
                this.actualizarPreciosAbonado();
                this.actualizarPreciosAmigoAbonado();
                this.sincronizarPlazasSeleccionadas();
            },
            clavePlaza(plaza) {
                return plaza && plaza.id !== undefined && plaza.id !== null ? String(plaza.id) : null;
            },
            inicializarRolAbonado() {
                if (!this.diaAbonado) {
                    return;
                }

                const abonadoId = this.datosAbonado && this.datosAbonado.id;
                const plazaAbonado = this.datosCompradores.find(comprador => comprador &&
                    comprador.abonado_id !== undefined && comprador.abonado_id !== null && abonadoId !== undefined &&
                    abonadoId !== null && String(comprador.abonado_id) === String(abonadoId)) || this.datosCompradores[0];

                this.abonadoPlazaId = this.clavePlaza(plazaAbonado);
                this.plazasConocidasIds = this.datosCompradores
                    .map(comprador => this.clavePlaza(comprador))
                    .filter(id => id !== null);
            },
            actualizarRolAbonado() {
                if (!this.diaAbonado) {
                    return;
                }

                const idsActuales = this.datosCompradores
                    .map(comprador => this.clavePlaza(comprador))
                    .filter(id => id !== null);
                const abonadoId = this.datosAbonado && this.datosAbonado.id;
                const plazaMarcadaAbonado = this.datosCompradores.find(comprador => comprador &&
                    comprador.abonado_id !== undefined && comprador.abonado_id !== null && abonadoId !== undefined &&
                    abonadoId !== null && String(comprador.abonado_id) === String(abonadoId));

                if (plazaMarcadaAbonado) {
                    this.abonadoPlazaId = this.clavePlaza(plazaMarcadaAbonado);
                } else if (this.abonadoPlazaId !== null && !idsActuales.includes(this.abonadoPlazaId)) {
                    this.abonadoPlazaId = null;
                }

                const nuevosIds = idsActuales.filter(id => !this.plazasConocidasIds.includes(id));

                if (this.abonadoPlazaId === null && nuevosIds.length > 0) {
                    this.abonadoPlazaId = nuevosIds[0];
                }

                this.plazasConocidasIds = idsActuales;
            },
            actualizarPreciosAbonado() {
                if (!this.diaAbonado) {
                    return;
                }

                this.actualizarRolAbonado();
                this.datosCompradores.forEach(comprador => {
                    const esAbonado = this.abonadoPlazaId !== null &&
                        this.clavePlaza(comprador) === this.abonadoPlazaId;

                    if (esAbonado) {
                        // El abonado usa la **fila real de taquilla** de su plaza: la que
                        // devuelve `butacas` marcada con `dia_abonado` y con sus propios
                        // `price_management_taquilla`/`price_management_taquilla_interno`.
                        // La tarifa normalizada que dejó la búsqueda (`descripcion`/`precio`)
                        // queda como respaldo y ya no arrastra los gastos de online.
                        const tieneTarifaAbonado = comprador.abonado_id &&
                            Array.isArray(comprador.precios) && comprador.precios.length > 0;
                        const tarifasDeTaquilla = this.tarifasDeTaquillaDelMapa(comprador, BANDERA_TARIFA_ABONADO);

                        comprador.precios = tarifasDelRol([
                            ...(tarifasDeTaquilla ? [tarifasDeTaquilla] : []),
                            ...(tieneTarifaAbonado ? [comprador.precios] : []),
                            this.preciosAbonado,
                            this.zona && this.zona.precios_abonados,
                            this.zona && this.zona.precios
                        ], BANDERA_TARIFA_ABONADO);

                        if (this.datosAbonado) {
                            comprador.nombre = this.datosAbonado.nombre;
                            comprador.apellidos = this.datosAbonado.apellidos;
                            comprador.abonado_id = this.datosAbonado.id;
                        }

                        return;
                    }

                    // Los acompañantes usan el catálogo de la zona y, cuando no viene o no
                    // trae su tarifa, los precios propios de la plaza: son los mismos que
                    // usa la venta normal.
                    comprador.precios = tarifasDelRol([
                        this.preciosAcompanante,
                        comprador.precios
                    ], BANDERA_TARIFA_ACOMPANANTE);
                });
            },
            actualizarPreciosAmigoAbonado() {
                if (!this.amigoAbonado) {
                    return;
                }

                this.datosCompradores.forEach(comprador => {
                    const tarifas = this.tarifasDeTaquillaDelMapa(comprador, BANDERA_TARIFA_AMIGO_ABONADO);
                    comprador.precios = preciosAmigoAbonadoDePlaza({
                        plaza: comprador,
                        tarifasDeTaquilla: tarifas,
                        preciosAmigoAbonado: this.preciosAmigoAbonado,
                        zona: this.zona
                    });
                });
            },
            clearButacas() {
                this.datosCompradores = [];
                this.actualizarRolAbonado();
                this.actualizarPreciosAmigoAbonado();
                this.sincronizarPlazasSeleccionadas();
            },
            borrarSeleccion() {
                const recintoAnexo = this.$refs.recintoAnexo;

                if (recintoAnexo && typeof recintoAnexo.clearButacas === 'function') {
                    recintoAnexo.clearButacas();
                }
            },
            bloquearButacas() {
                if ((this.diaAbonado || this.amigoAbonado) &&
                    this.datosCompradores.length < this.asientosMinimos) {
                    this.$toast.error(`Debe seleccionar al menos ${this.asientosMinimos} plazas`);
                    return;
                }

                // El paso 3 consume estas listas: se reparte el catálogo por rol también aquí
                // para que una selección hecha sin pasar por el mapa llegue filtrada.
                this.actualizarPreciosAbonado();
                this.actualizarPreciosAmigoAbonado();

                const data = this.datosCompradores.map(plaza => {
                    return { plazaId: plaza.id }
                });

                const params = {
                    filters: {},
                    event_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id,
                    data: data
                }

                if (this.diaAbonado) {
                    params.datos_abonado = this.datosAbonado;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params)
                    .then(({ data }) => {
                        sessionStorage.setItem('session_id', data.session_id);
                        this.$emit('goTo', 3, this.datosCompradores, data.session_id);
                    })
                    .catch(() => {
                        this.$toast.error('Butaca/s ocupada/s');
                    });
            },
            getPlazas() {
                this.loading = true;
                const params = {
                    filters: this.filtrosPeticionPlazas(),
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.recinto.id,
                    region_id: this.zona.id
                }
                const rutaPlazas = this.diaAbonado
                    ? 'back.events.sesiones.regiones.plazas.taquilla'
                    : 'back.events.sesiones.taquilla.recinto.zonas-anexas.butacas';

                this.$store.dispatch(this.config.getVuexAlias(rutaPlazas), params).then(res => {
                    this.plazas = res.data && Array.isArray(res.data.data) ? res.data.data : [];

                    if (this.diaAbonado && !this.continuarConAsiento && !this.preseleccionarPlazaAbonado) {
                        this.datosCompradores = this.datosCompradores.filter(comprador => {
                            const plazaReal = this.plazas.find(plaza => String(plaza.id) === String(comprador.id));
                            return this.esPlazaCompleta(comprador) && this.plazaDisponibleParaPreseleccion(plazaReal);
                        });
                    }

                    this.actualizarRolAbonado();
                    this.actualizarPreciosAmigoAbonado();
                    this.sincronizarPlazasSeleccionadas();
                }).catch(() => {
                    console.warn('Ha ocurrido un error recuperando las plazas');
                }).finally(() => {
                    this.loading = false;
                });
            },
            /**
             * El endpoint de butacas de la región alterna su catálogo con las banderas
             * `dia_abonado` y `amigo_abonado`: sin ellas devuelve precios normales. Cada
             * flujo añade únicamente su propia bandera y la venta normal no modifica su
             * petición.
             *
             * Viajan como `1` numérico porque Laravel valida el campo con la regla
             * `boolean`, que rechaza la cadena «true» que produce el query string al
             * serializar un booleano.
             */
            filtrosPeticionPlazas() {
                const filters = {};

                if (this.diaAbonado) {
                    filters.dia_abonado = 1;
                }

                if (this.amigoAbonado) {
                    filters.amigo_abonado = 1;
                }

                return filters;
            },
            cambiarPaso() {
                this.$emit('cambiarPaso', 1, true);
            },
            bloquearAsientosManual(concepto, etiqueta) {
                this.loading = true;

                const params = {
                    filters: {},
                    concepto: concepto,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id,
                    n_butacas: this.asientos_maximos,
                    plazasSeleccionadas: this.datosCompradores,
                    asientos: []
                };

                if(etiqueta){
                    params.etiqueta_bloqueo_id = etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos'), params).then(res => {
                    if (this.recinto) {
                        this.getPlazas();
                    }
                    this.$emit('reset');
                    this.reload += 1
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModalBloquearAsientos() {
                this.$modal.show('bloquearButacas');
            },
            closeModalBloquearAsientos() {
                this.$modal.hide('bloquearButacas');
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            crearCarrito() {
                const params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                })
            },
            setItemsCarrito() {
                this.disableButtonCart = true;

                const params = {
                    filters: {},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO');
                    this.$router.push({path: "/admin/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.datosCompradores.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precios[0].id
                        },
                        id: plaza.id,
                        event_id: this.evento_id,
                        event_session_id: this.sesion_id,
                        region_id: plaza.region_id
                    })
                });

                return plazas;
            }
        },
        computed: {
            plazasCompletas() {
                return this.datosCompradores.filter(plaza => this.esPlazaCompleta(plaza));
            },
            plazasSeleccionadasIds() {
                return this.datosCompradores.map(comprador => comprador.id);
            },
            evento_id() {
                return this.$route.params.evento_id;
            },
            sesion_id() {
                return this.$route.params.sesion_id;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            }
        },
        mounted() {
            window.addEventListener('update-plano', this.getCarritoActivo);
        },
        components: { TitleComponent, RecintoAnexoComponent, TusPlazasComponent, BloquearButacas }
    }
</script>
